<template>
        <iframe width="100%" :style="{aspectRatio: aspectRatio}" :src="embeedSrc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({

    props: {
        embeedSrc: {
            type: String,
            required: true,
        },
        aspectRatio: {
            type: String,
            default: '16/9',
        },
    },

    methods: {
        onReady() {
            // this.$refs.youtube.playVideo()
        },
    },

    computed: {
        videoSrc() {
            return `https://www.youtube.com/watch?v=${this.videoId}`
        },
    },
})
</script>
